<template>
  <div class="pending-txs">
    <ul class="list-plain">
      <transition-group name="fade-left">
        <li
          v-for="tx in transactions.pending"
          :key="tx.hash"
          class="pending-txs__tx py-1 px-1 mt-1"
        >
          <div class="flex">
            <div class="flex-grow mr-2">
              {{ tx.title }}
            </div>
            <a
              :href="`${etherscan_url}/tx/${tx.hash}`"
              target="_blank"
              v-tippy
              title="view on Etherscan"
              class="mr-1"
            >
              <MtxSvg icon="icon-link" />
            </a>
            <button @click="removeTx(tx.hash)" class="btn--link">
              <MtxSvg icon="icon-close" />
            </button>
          </div>
          <TxProgress :tx="tx.hash" :showInfo="false" :maxWidth="0" />
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  data: () => ({
    etherscan_url: process.env.VUE_APP_ETHERSCAN_URL
  }),
  computed: mapState(["transactions"]),
  methods: mapActions(["removeTx"])
}
</script>

<style lang="scss">
.pending-txs {
  position: fixed;
  right: 0;
  bottom: 0;

  color: #fff;

  &__tx {
    min-width: 250px;
    background: $offBlack;
  }
}
</style>
